import $script from 'scriptjs'
import utilsService from '@/services/amio/utils.service'

const SCRIPT_URL = 'https://chat.cdn-plain.com/index.js'
const APP_ID = 'liveChatApp_01M2JHY5HXQEK8YHZX87PN4BCA'

class PlainChatService {
  constructor() {
    this._initialized = false
    this._loading = null
  }

  open() {
    return this._customerDetails().then(customerDetails => {
      return this._ensureInitialized(customerDetails).then(() => {
        if (customerDetails && window.Plain && typeof window.Plain.setCustomerDetails === 'function') {
          window.Plain.setCustomerDetails(customerDetails)
        }
        if (window.Plain && typeof window.Plain.open === 'function') {
          window.Plain.open()
        }
      })
    })
  }

  _ensureInitialized(customerDetails) {
    if (this._initialized) return Promise.resolve()
    if (this._loading) return this._loading

    this._loading = new Promise((resolve, reject) => {
      $script(SCRIPT_URL, () => {
        try {
          const initConfig = {
            appId: APP_ID,
            hideLauncher: true,
            entryPoint: { type: 'default' }
          }
          if (customerDetails) initConfig.customerDetails = customerDetails
          window.Plain.init(initConfig)
          this._initialized = true
          resolve()
        } catch (err) {
          reject(err)
        }
      })
    }).catch(err => {
      this._loading = null
      throw err
    })

    return this._loading
  }

  async _customerDetails() {
    try {
      const identity = await utilsService.getPlainChatIdentity()
      if (identity?.email && identity?.email_hash) {
        return {
          email: identity.email,
          emailHash: identity.email_hash
        }
      }
    } catch (err) {
      return null
    }
    return null
  }
}

export default new PlainChatService()
